import $ from 'jquery';

export function formProgressTracker(fieldset, stepValue) {
    // On load if there's no step value (processed by step-continue.js) then assign to 1
    // as it should always be the active fieldset
    if (!stepValue) {
        stepValue = 1;
    }

    var findAllFieldsets = $(fieldset).closest('.c-form').find('fieldset');
    var findLengthOfTotalSteps = findAllFieldsets.length;
    var calculateProgress = Math.round((stepValue / findLengthOfTotalSteps) * 100) + '%';

    $(fieldset).closest('.js-donationForm').find('.js-formProgressTracker').css('width', calculateProgress);
}

// Check current step on load.
window.addEventListener('load', function() {
    $('.js-donationForm').each(function() {
        var findCurrentFieldsetOnLoad = $(this).find('fieldset:visible');
        formProgressTracker(findCurrentFieldsetOnLoad);
    });
});
